var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.345 10.8055C15.2153 11.7541 14.7311 12.6247 13.983 13.2549C13.2349 13.8851 12.274 14.2317 11.2797 14.23C5.5032 14.23 0.803473 9.70793 0.803473 4.14988C0.801691 3.19317 1.16191 2.26855 1.81685 1.54872C2.47179 0.828882 3.37666 0.363055 4.36246 0.238239C4.61175 0.208951 4.86419 0.258022 5.08211 0.378127C5.30003 0.498232 5.47173 0.682928 5.57159 0.904645L7.1081 4.20518V4.21358C7.18455 4.3833 7.21612 4.56859 7.2 4.75292C7.18388 4.93724 7.12056 5.11485 7.0157 5.26989C7.00261 5.28879 6.98878 5.30629 6.97423 5.32379L5.45955 7.0514C6.00446 8.11682 7.16266 9.22143 8.28448 9.74713L10.0552 8.29742C10.0726 8.28335 10.0909 8.27026 10.1098 8.25822C10.2708 8.1549 10.456 8.09183 10.6487 8.07472C10.8414 8.05761 11.0355 8.08699 11.2134 8.16022L11.2229 8.16442L14.6502 9.64213C14.8811 9.73787 15.0735 9.90294 15.1987 10.1126C15.3239 10.3224 15.3753 10.5654 15.345 10.8055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.e81fcae886c009d98a910136fd91219f.svg";
export { ForwardRef as ReactComponent };